<template>
  <div class="search-wrapper" v-if="ready">
    <div class="filters-wrapper">
      <div class="left-side">
        <vs-button
          shadow
          :active="this.currSearchType === photos"
          @click="handleChangeTypePhotos()"
          >Photos</vs-button
        >
        <vs-button
          shadow
          :active="this.currSearchType === users"
          @click="handleChangeTypeUsers()"
          >Users</vs-button
        >
        <vs-button shadow @click="handleChangeTypeCollections()"
          >Collections</vs-button
        >
      </div>
    </div>
    <div class="search-heading">
      {{ this.$route.params.query }}
      <span class="total">{{ this.data.total }}</span>
    </div>
    <router-view :data="data" v-if="ready"></router-view>
    <div class="intersect">
      <intersect @enter="scroll()">
        <div class="loading">Loading...</div>
      </intersect>
    </div>
  </div>
</template>

<script>
  import Intersect from "vue-intersect";
  export default {
    name: "Search",
    components: {
      Intersect,
    },
    data() {
      return {
        currSearchType: this.$route.name,
        searchType: {
          photos: "photos",
          users: "users",
        },
        ready: false,
        data: [],
        page: 1,
      };
    },
    methods: {
      scroll() {
        this.page = this.page + 1;
      },
      handleChangeTypeUsers() {
        this.$router.push(`/s/users/${this.$route.params.query}`);
      },
      handleChangeTypeCollections() {
        this.$router.push(`/s/collections/${this.$route.params.query}`);
      },
      handleChangeTypePhotos() {
        this.$router.push(`/s/photos/${this.$route.params.query}`);
      },
      handleGetSearch() {
        this.$http
          .get(
            `/search/${this.currSearchType}?page=${this.page}&query=${this.$route.params.query}&per_page=30`
          )
          .then((res) => {
            this.data = res.data;
            console.log(res.data);
            this.ready = true;
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
    watch: {
      currSearchType() {
        this.handleGetSearch();
      },
      page() {
        this.handleGetSearch();
      },
    },
    created() {
      this.handleGetSearch();
    },
  };
</script>

<style lang="scss" scoped>
  .search-wrapper {
    width: 98%;
    align-self: center;
    min-height: 100vh;
    display: flex;
    padding-top: 1.2rem;
    flex-direction: column;

    .filters-wrapper {
      display: flex;
      flex-direction: row;
      width: 100%;
      min-height: 8%;
      align-self: center;
      background-color: white;
      border-radius: 15px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.06);

      .left-side {
        display: flex;
        flex-direction: row;
        height: 100%;
      }
    }
    .search-heading {
      width: 98%;
      padding: 1.3rem 5px;
      border-bottom: solid 1.2px rgba(49, 49, 49, 0.3);
      font-size: 2rem;
      margin: 1.3rem 0;
      text-transform: capitalize;
      font-weight: 700;
    }
    .total {
      font-size: 17px;
      font-weight: 400;
    }
  }
</style>
